import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Phone, CheckCircle, ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { serviceDetails, contactInfo } from '../mockData';

const ServiceDetailPage = () => {
    const { slug } = useParams();
    const service = serviceDetails[slug];

    if (!service) {
        return (
            <div className="min-h-screen">
                <Header />
                <div className="container mx-auto px-4 py-20 text-center">
                    <h1 className="text-3xl font-bold mb-4">Hizmet Bulunamadı</h1>
                    <Link to="/hizmetler" className="text-blue-600 hover:underline">
                        Hizmetler sayfasına dön
                    </Link>
                </div>
                <Footer />
            </div>
        );
    }

    const seoTitle = service.seoTitle || `${service.title} | Ankara Merkez Far`;
    const seoDescription = service.seoDescription || service.description;

    return (
        <div className="min-h-screen">
            <SEO
                title={seoTitle}
                description={seoDescription}
                url={`https://ankaramerkezfar.com/hizmet/${slug}`}
                type="article"
                image={service.image}
            />
            <Header />

            {/* Hero Section */}
            <section className="relative bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16 md:py-20">
                <div className="container mx-auto px-4">
                    <Link
                        to="/hizmetler"
                        className="inline-flex items-center space-x-2 text-blue-400 hover:text-blue-300 mb-6 transition-colors"
                    >
                        <ArrowLeft size={20} />
                        <span>Tüm Hizmetlere Dön</span>
                    </Link>
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">{service.title}</h1>
                    <p className="text-lg text-gray-300 max-w-2xl">{service.description}</p>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-16 md:py-24 bg-white">
                <div className="container mx-auto px-4">
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        {/* Image */}
                        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                            <img
                                src={`${service.image}?w=800&h=600&fit=crop`}
                                alt={service.title}
                                className="w-full h-auto object-cover"
                            />
                        </div>

                        {/* Features */}
                        <div>
                            <h2 className="text-3xl font-bold text-gray-900 mb-6">Hizmet Özellikleri</h2>
                            <ul className="space-y-4">
                                {service.features.map((feature, index) => (
                                    <li key={index} className="flex items-start space-x-3">
                                        <CheckCircle className="text-green-500 flex-shrink-0 mt-1" size={24} />
                                        <span className="text-lg text-gray-700">{feature}</span>
                                    </li>
                                ))}
                            </ul>

                            <div className="mt-10 p-6 bg-blue-50 rounded-xl">
                                <h3 className="text-xl font-bold text-gray-900 mb-4">
                                    Fiyat Teklifi Alın
                                </h3>
                                <p className="text-gray-700 mb-6">
                                    Bu hizmet hakkında detaylı bilgi ve ücretsiz fiyat teklifi için bizi hemen arayın.
                                </p>
                                <a
                                    href={`tel:${contactInfo.phone}`}
                                    className="inline-flex items-center space-x-2 bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-all hover:scale-105 shadow-lg text-lg font-semibold"
                                >
                                    <Phone size={24} />
                                    <span>{contactInfo.phone}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default ServiceDetailPage;
